import Para from "@/atoms/text/Para";

export default function CardLink({ data }) {
  return (
    <ul className="card-wrapper w-100 fx fx--w fx--ch to-top mb-7-d mb-6">
      {data.map((card, idx) => (
        <li key={idx} className="ps-r bc-white pv-5 pl-4 pr-4">
          <div className="fx">
            {card.icon && (
              <card.icon width="30" height="30" className="icon mr-1" />
            )}
            <h6 className="card-title text--lg secondary-font tc-black bold mb-2">
              {card.title}
            </h6>
          </div>
          <Para className="text--md">{card.content}</Para>
          <a href={card.href} className="full" />
        </li>
      ))}
      <style jsx>{`
        .card-wrapper {
          gap: 40px;
        }
        @media (max-width: 1200px) {
          .card-wrapper {
            gap: 24px;
          }
        }
        .card-wrapper li {
          outline: 2px solid #e2e2e7;
          border-radius: 8px;
          max-width: 360px;
          min-height: 142px;
        }
        .card-wrapper li:hover {
          box-shadow: 0 4px 22px 4px rgba(51, 57, 61, 0.14);
        }
        .card-wrapper li:hover h6.card-title {
          color: #3270d8;
        }
        .card-wrapper li .icon {
          vertical-align: bottom;
        }
      `}</style>
    </ul>
  );
}
